var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconResiliencia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F7F8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 13.6667L17 20.3333V30.3333C17 39.5833 23.4 48.2333 32 50.3333C40.6 48.2333 47 39.5833 47 30.3333V20.3333L32 13.6667ZM43.6667 30.3333C43.6667 37.8667 38.7 44.8167 32 46.8833C25.3 44.8167 20.3333 37.8667 20.3333 30.3333V22.5L32 17.3167L43.6667 22.5V30.3333ZM24.35 31.3167L22 33.6667L28.6667 40.3333L42 27L39.65 24.6333L28.6667 35.6167L24.35 31.3167Z",
    fill: "#043873"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconResiliencia);
export default __webpack_public_path__ + "static/media/icon-resiliencia.3b5074ed44a75e79341e6f6fc10f6de6.svg";
export { ForwardRef as ReactComponent };